import { IonButton, IonContent } from "@ionic/react";
import { AppHeader } from "../../components/Header/AppHeader";

const ActivityLog: React.FC = () => {
	return (
		<>
			<AppHeader title="ActivityLog" />
			<IonContent fullscreen className="ion-padding">
				<div className="container">
					<strong>Activity Log</strong>
					<p>Page content</p>
				</div>
			</IonContent>
		</>
	);
};

export default ActivityLog;
